// encryptionHelper.js
import forge from 'node-forge';

const CUSTOMER_PUBLIC_KEY = process.env.REACT_APP_CUSTOMER_PUBLIC_KEY;
const CUSTOMER_PRIVATE_KEY = process.env.REACT_APP_CUSTOMER_PRIVATE_KEY;
const AES_KEY_SIZE = 32; // 256 bits
const IV_SIZE = 16;      // 128 bits

const decodeKeyPem = (base64EncodedKey) => {
  const pemKey = atob(base64EncodedKey); 
  return pemKey;
};

export const decodeTrimmedKeyPem = (base64EncodedKey) => {
  const pemKey = atob(base64EncodedKey); 
  const cleanedKey = pemKey
    .replace(/-----BEGIN (RSA )?(PRIVATE|PUBLIC) KEY-----/g, '')
    .replace(/-----END (RSA )?(PRIVATE|PUBLIC) KEY-----/g, '')
    .replace(/\s+/g, '');
  return cleanedKey;
};

export function encryptData(publicKeyBase64, jsonData) {
  const publicKey = forge.pki.publicKeyFromPem(decodeKeyPem(publicKeyBase64));

  const aesKey = forge.random.getBytesSync(AES_KEY_SIZE);
  const iv = forge.random.getBytesSync(IV_SIZE);

  const cipher = forge.cipher.createCipher('AES-CBC', aesKey);
  cipher.start({ iv });
  cipher.update(forge.util.createBuffer(jsonData, 'utf8'));
  cipher.finish();
  const encryptedData = forge.util.encode64(cipher.output.getBytes());

  const encryptedAesKey = publicKey.encrypt(aesKey, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
    mgf1: { md: forge.md.sha256.create() }
  });

  return {
    encryptedData,
    encryptedKey: forge.util.encode64(encryptedAesKey),
    iv: forge.util.encode64(iv)
  };
}

export function decryptData(privateKeyBase64, encryptedData, encryptedKey, iv) {
  const privateKey = forge.pki.privateKeyFromPem(decodeKeyPem(privateKeyBase64));

  const aesKey = privateKey.decrypt(forge.util.decode64(encryptedKey), 'RSA-OAEP', {
    md: forge.md.sha256.create(),
    mgf1: { md: forge.md.sha256.create() }
  });

  const decipher = forge.cipher.createDecipher('AES-CBC', aesKey);
  decipher.start({
    iv: forge.util.decode64(iv)
  });
  decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedData)));
  const result = decipher.finish();
  if (!result) throw new Error('Decryption failed');

  return decipher.output.toString('utf8');
}

export function decryptEmail(encryptedBase64Email) {
    try {
      debugger;
      // Decode base64 to PEM format
      const pemPrivateKey = atob(CUSTOMER_PRIVATE_KEY)
      const privateKey = forge.pki.privateKeyFromPem(pemPrivateKey)

      // Decode the encrypted base64 input
      const encryptedBytes = forge.util.decode64(encryptedBase64Email)

      const decrypted = privateKey.decrypt(encryptedBytes, 'RSA-OAEP', {
        md: forge.md.sha256.create(),
      })
      return decrypted
    } catch (err) {
      console.error('RSA decryption failed:', err)
      return null
    }
  }

// export function encryptEmail(plaintextEmail) {
//     const pemPublicKey = atob(CUSTOMER_PUBLIC_KEY)
//     const publicKey = forge.pki.publicKeyFromPem(pemPublicKey)
//     const encrypted = publicKey.encrypt(plaintextEmail, 'RSA-OAEP', {
//       md: forge.md.sha256.create(),
//     })
//     const encryptedEmail = encodeURIComponent(forge.util.encode64(encrypted))
//   }
